import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text } from 'components/ui';
import Icon from 'components/Icon';
import { colors } from 'style/config';

/** Renders an X icon with a localized status text for special sku flags (e.g. "Online Only", "In Store Only"). */
const StatusLabel = ({ textKey, getText }) => (
    <Text
        lineHeight={'none'}
        fontSize='sm'
        fontWeight='bold'
        color={colors.gray}
    >
        <Icon
            name='xBold'
            size={16}
            marginRight={2}
        />
        {getText(textKey)}
    </Text>
);

StatusLabel.propTypes = {
    textKey: PropTypes.string.isRequired,
    getText: PropTypes.func.isRequired
};

export default wrapFunctionalComponent(StatusLabel, 'StatusLabel');
